/* eslint-disable no-useless-escape */

export default {
    CZ: {
          0: 'aplikace pro změnu hesla je připravena k činnosti',
        100: 'aplikace pro změnu hesla je připravena k činnosti',
        101: 'ticket přijat z nepovolené IP adresy',
        102: 'ticket je příliš krátký ',
        103: 'neexistující komunikační tiket klienta',
        200: 'Kód byl v pořádku přijat, můžeme pokračovat.',
        201: 'Takový kód neexistuje. Zkontrolujte si prosím ještě jednou kód v zaslaném dopise.',
        202: 'Příliš špatných pokusů  přístup z této adresy byl dočasně zablokován',
        203: 'Váš kód je v pořádku, ale účet v LIANE ještě nebyl vytvořen. Účty se automaticky vytvoří do 48 hodin po zápisu ke studiu.',
        204: 'Tento kód byl již jednou použit. Kontaktujte prosím správu sítě LIANE',
        300: 'Úspěšné ověření identity, můžeme pokračovat změnou hesla.',
        301: 'Nepodařilo se ověřit vaši identitu. Prosím obnovte aplikaci stiskem F5 a zkuste to znovu.',
        302: 'Nepodařilo se ověřit vaši identitu. Prosím obnovte aplikaci stiskem F5 a zkuste to znovu.',
        303: 'Chyba ověření identity, zkontrolujte si prosím své rodné číslo a zadejte poslední čtyři číslice (za lomítkem).',
        400: 'Heslo bylo úspěšně vytvořeno',
        401: 'Porušení bezpečnosti aplikace. Prosím obnovte aplikaci stiskem F5 a zkuste to znovu.',
        402: 'Porušení bezpečnosti aplikace. Prosím obnovte aplikaci stiskem F5 a zkuste to znovu.',
        403: 'Heslo se z technických důvodů na naší straně nepodařilo změnit. Počkejte prosím 30 minut a pak zkuste celý postup zopakovat. V případě opakovaných problémů kontaktujte prosím správu sítě LIANE.',
        410: 'Vybrané heslo je v pořádku. Stiskněte tlačítko odeslat pro provedení změny hesla.',
        411: 'Minimální délka hesla je 10 znaků',
        412: 'Heslo musí obsahovat min. jednu číslici',
        413: 'Heslo musí obsahovat min. jeden alfanumerický znak',
        414: 'Heslo může obsahovat pouze písmena, číslice a následující znaky _@#$%&*\/+!?§.',
        415: 'Heslo nesmí být stejné jako heslo pro vzdálený přístup',
        416: 'Heslo nesmí obsahovat rodné číslo, jméno, příjmení a blokované fráze a to ani pozpátku',
        600: 'Uživatel v pořádku ověřen',
        601: 'Neexistující uživatel',
        602: 'Uživatel má zablokovaný účet.',
        603: 'Uživatel nemá registrované mobilní číslo',
        604: 'Uzamčená IP uživatele',
        803: 'Pro tohoto uživatele je služba zasílání SMS momentálně uzamčena',
        700: 'Ověření RC proběhlo v pořádku, na mobilní telefon byl zaslán ověřovací kód.',
        701: 'Ověření RC proběhlo v pořádku, nebyl nalezen registrovaný telefon.',
        702: 'Ověření RC proběhlo v pořádku, při odeslání SMS se vyskytla chyba. Zkuste to prosím později, v případě opakovaných problémů kontaktuje prosím správu LIANE.',
        800: 'Ověření proběhlo v pořádku, je možno zaslat nové heslo',
        801: 'Porušení bezpečnosti aplikace. Prosím obnovte aplikaci stiskem F5 a zkuste to znovu.',
        802: 'Zadaný SMS kód neodpovídá zaslanému kódu'

    },
    EN: {
          0: 'This form is ready to help you with creating a new password',
        100: 'This form is ready to help you with creating a new password',
        101: 'Security verification error. Please reload the form and try again later.',
        102: 'Security verification error. Please reload the form and try again later.',
        103: 'neexistující komunikační tiket klienta',
        200: 'Code accepted, you can continue to next step.',
        201: 'Invalid code. Please read the code in letter carefully.',
        202: 'Your computer address was temporarily blocked due to security concerns. ',
        203: 'This code is correct, but you need to wait until your LIANE account will be created. Please note that the account will be created automatically after you will signup to study at study department.',
        204: 'This code was already used. Please contact the LIANE administrators.',
        300: 'Identity verified, now you can create the new password',
        301: 'Identity verification error. Please reload the form and try again later.',
        302: 'Identity verification error. Please reload the form and try again later.',
        303: 'Identity verification error. Please check again your pseudobirth number and enter last four digits.',
        400: 'New password created successfully.',
        401: 'Security verification error. Please reload the form and try again later.',
        402: 'Security verification error. Please reload the form and try again later.',
        403: 'System error. Please reload the form and try again after 30 minutes. If you see this message again, please contact LIANE administrators for help.',
        410: 'This is a valid password. You can use it.',
        411: 'Minimum password length is 10 characters.',
        412: 'At least one number is required in the password.',
        413: 'At least one letter is required in the password.',
        414: 'Password can be composed only from digits, letters and following characters _@#$%&*\/+!?§.',
        415: 'You can not use the same password as for remote LIANE access.',
        416: 'Your password is based on illegal combination of your personal data. Please create another one.',
        600: 'Valid username - you can continue.',
        601: 'Invalid username - please check what you typed.',
        602: 'User account disabled - please contact LIANE administrators for help.',
        603: 'No phone registered to this username - please contact LIANE administrators for help.',
        604: 'You IP address has been blocked for security reasons.',
        803: 'You can not use this service - please contact LIANE administrators for help.',
        700: 'Successful verification - check the message with the code sent to your phone',
        701: 'Successful verification - but you do not have phone number registered. Please contact LIANE administrators for help.',
        702: 'Successful verification - error occured in SMS service. Please reload the form and try again after 30 minutes. If you see this message again, please contact LIANE administrators for help.',
        800: 'Successful verification, now you can create the new password.',
        801: 'Security verification error. Please reload the form and try again later.',
        802: 'Security verification error. Please reload the form and try again later.'
    }
};
